import { render, staticRenderFns } from "./ArticleInfoFullWidthTemplate.vue?vue&type=template&id=7285480d"
import script from "./ArticleInfoFullWidthTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoFullWidthTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoFullWidthTemplate.vue?vue&type=style&index=0&id=7285480d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports